import { delay, put, select, takeLatest } from 'redux-saga/effects';
import { activitiesActions } from '../activities';
import * as communitiesJoinRequests from '../communitiesJoinRequests';
import * as notificationCounters from '../notificationCounters';
import { ACTIVITY_TYPES } from '../../../constants';
import {
  selectActivitiesActiveTab,
  selectActivityCounterByType,
} from '../selectors/activitiesSelector';

const { MEMBER_INVITATIONS, NOTIFICATIONS, JOIN_REQUESTS } = ACTIVITY_TYPES;

function* setDefaultTab() {
  yield delay(0);

  const tab = yield select(selectActivitiesActiveTab);
  const notifyCount = yield select(selectActivityCounterByType(NOTIFICATIONS));
  const requestCount = yield select(selectActivityCounterByType(JOIN_REQUESTS));
  const inviteCount = yield select(
    selectActivityCounterByType(MEMBER_INVITATIONS),
  );

  const getTabToSwitch = {
    [MEMBER_INVITATIONS]: () => {
      if (inviteCount) return null;
      return requestCount ? JOIN_REQUESTS : NOTIFICATIONS;
    },
    [JOIN_REQUESTS]: () => {
      if (requestCount) return null;
      return notifyCount ? NOTIFICATIONS : MEMBER_INVITATIONS;
    },
    [NOTIFICATIONS]: () => {
      if (notifyCount) return null;

      return requestCount ? JOIN_REQUESTS : MEMBER_INVITATIONS;
    },
  };

  const tabToSwitch = getTabToSwitch[tab]();
  if (tabToSwitch) {
    yield put(activitiesActions.changeTab(tabToSwitch));
  }
}

export default function* activitiesRootSaga() {
  yield takeLatest(
    [
      communitiesJoinRequests.consts.SUCCEED,
      notificationCounters.consts.UPDATE_ACTIVITY_COUNT,
    ],
    setDefaultTab,
  );
}



// WEBPACK FOOTER //
// ./src/redux/communities/sagas/activitiesSaga.js